export function letF<T,K>(toBind: T, f: (t: T) => K) {
  return f(toBind);
}

export function block<K>(f: () => K) {
  return f()
}
